module.exports = __webpack_public_path__ + "assets/39bc0b9918c1ccaac575a7b31cd373a8.mp3";